import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type ContactRelationshipsFetchedPayload = LabeledValuePayload[];

export type ContactRelationshipsFetchedAction = {
	type: 'CONTACT_RELATIONSHIPS_FETCHED';
	payload: ContactRelationshipsFetchedPayload;
};

export default (payload: ContactRelationshipsFetchedPayload): ContactRelationshipsFetchedAction => ({
	type: 'CONTACT_RELATIONSHIPS_FETCHED',
	payload,
});
